import { render, staticRenderFns } from "./PublicFilesEditor.vue?vue&type=template&id=5775ffe0&"
import script from "./PublicFilesEditor.vue?vue&type=script&lang=js&"
export * from "./PublicFilesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/nextcloud/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5775ffe0')) {
      api.createRecord('5775ffe0', component.options)
    } else {
      api.reload('5775ffe0', component.options)
    }
    module.hot.accept("./PublicFilesEditor.vue?vue&type=template&id=5775ffe0&", function () {
      api.rerender('5775ffe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/text/src/components/PublicFilesEditor.vue"
export default component.exports